<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-timeline>
      <a-timeline-item v-for="(follow,index) in followList" :key="index" color="green">
        <p>{{ follow.createTime }}  <font size="2px">{{ follow.modifierName }}</font></p>
        <p>跟进结果:  {{ follow.resultType == 1 ? '暂无意向' : follow.resultType == 2 ? '未联系上' : follow.resultType == 3 ? '有意向' : '无效信息' }}</p>
        <p>跟进方式:  {{ follow.resultType == 1 ? '电话' : follow.resultType == 2 ? '微信' : follow.resultType == 3 ? '在线' : '来访' }}</p>
        <p>微信添加结果:  {{ follow.resultType == 1 ? '已加微信' : follow.resultType == 2 ? '添加未通过' : follow.resultType == 3 ? '搜不到微信' : '未加微信' }}</p>
        <p>下次跟进时间:  {{ follow.nextFollowTime }}</p>
        <p>备注:  {{ follow.remark }}</p>
      </a-timeline-item>
    </a-timeline>
  </a-drawer>
</template>

<script>
import { queryFollowListById } from '@/api/biz/user'
export default {
  name: 'FollowForm',
  data () {
    return {
      formTitle: null,
      open: false,
      followList: []
    }
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getList(id) {
      this.open = true
      this.formTitle = '跟进记录'
      const param = { userId: id }
      queryFollowListById(param).then(response => {
        this.followList = response.data
      })
    },
    onClose () {
      this.open = false
    }
  }
}

</script>

<style scoped>

</style>
